/**
 *
 *
 */
import utils from "@/utils";
export default {

    maxChainIndex: 7, // 最多展示8条内容 和 1条更多信息
    /**
     * 获取每日 时间点、时间段的链表数据
     * @param dayItems
     * @param hourChainItems
     * @param upFoldIndex 向上折叠
     * @param downFoldIndex 向下折叠
     */
    setChainItems: function(dayItems, hourChainItems, upFoldIndex, downFoldIndex){
        dayItems.forEach((dayItem, dayIndex)=>{
            // 每天的所有事
            let hourMatters = dayItem.matterArray.filter((item)=>{
                return item.info.crossDays === 0 && item.info.startTime > -1
            });

            // 每天的链表对象
            let hourChainItem = hourChainItems[dayIndex];

            // 筛选未折叠的事项
            if(upFoldIndex > -1 || downFoldIndex < 24){
                this.getFoldItems(hourChainItem, hourMatters, upFoldIndex, downFoldIndex);
            }

            // 排序
            hourMatters.sort((nextItem, item)=>{
                const itemKey = item.info.startTime;
                const nextItemKey = nextItem.info.startTime;

                if(itemKey === nextItemKey){
                    const itemTimeType = item.info.endTime === -1;
                    const nextItemTimeType = nextItem.info.endTime === -1;

                    if(itemTimeType === nextItemTimeType
                        && !itemTimeType){
                        return item.info.endTime - nextItem.info.endTime
                    }else{
                        return itemTimeType - nextItemTimeType
                    }
                }else{
                    return nextItemKey - itemKey
                }
            })

            // 递归取出
            const chainItems = [];
            this.getChainItem(chainItems, hourMatters);
            // <限制条数时，均分宽度
            this.setFreeWidth(chainItems, dayIndex, upFoldIndex);
            hourChainItem.chainItems = chainItems;
        })
        return hourChainItems
    },

    /**
     * 获取折叠事项
     * @param hourChainItem
     * @param hourMatters
     * @param upFoldIndex
     * @param downFoldIndex
     */
    getFoldItems: function(hourChainItem, hourMatters, upFoldIndex, downFoldIndex){

        let upFoldTime = "00:00:00", downFoldTime = "24:00:00";
        if (upFoldIndex > -1){
            // upFoldTime = (upFoldIndex + 1) * 60
            upFoldTime = utils.addZero(upFoldIndex+1) + ":00:00"
        }
        if (downFoldIndex < 24){
            // downFoldTime = (downFoldIndex + 1) * 60
            downFoldTime = utils.addZero(downFoldIndex) + ":00:00"
        }
        for (let i=0,l=hourMatters.length; i<l; i++){
            const item = hourMatters[i];
            const title = item.info.title;
            let remove = false;

            let startTime = utils.minuteToTime(item.info.startTime);
            startTime = startTime.hour + ":" + startTime.minute + ":00";

            if(item.info.endTime === -1){
                // 时间点

                if(startTime < upFoldTime){
                    // 上折叠 数据
                    hourChainItem.upFoldItems.push(this.getFoldMatter(title, startTime, ""))
                    remove = true;
                }else if(startTime > downFoldTime){
                    // 下折叠 数据
                    hourChainItem.downFoldItems.push(this.getFoldMatter(title, startTime, ""))
                    remove = true;
                }
            }else{
                let endTime = utils.minuteToTime(item.info.endTime);
                endTime = endTime.hour + ":" + endTime.minute + ":00";

                // 时间段
                if(startTime < upFoldTime){
                    // 上折叠 数据
                    hourChainItem.upFoldItems.push(this.getFoldMatter(title, startTime, endTime))
                    remove = true;
                }else if(endTime > downFoldTime){
                    // 下折叠数据
                    hourChainItem.downFoldItems.push(this.getFoldMatter(title, startTime, endTime))
                    remove = true;
                }
            }

            if (remove){
                hourMatters.splice(i, 1);
                i--;
                l--;
            }

        }
    },
    getFoldMatter: function(title, startTime, endTime){
        const item = {
            title: title,
            time: "",
        }
        if( endTime === ""){
            // 时间点
            item.time = startTime.slice(0,5);
        }else{
            // 时间段
            item.time = startTime.slice(0,5) + "-" + endTime.slice(0,5);
        }
        return item
    },
    /**
     *
     * @param chainItems
     * @param hourMatters
     * @returns {*}
     */
    getChainItem: function(chainItems, hourMatters){

        let chainItem = {
            chainMatter: [],

            chainIndex: chainItems.length
        };
        let nextChain;

        nextChain = this.getNextMatter(chainItem, hourMatters);
        if(chainItem.chainMatter.length > 0){
            chainItems.push(chainItem);
        }

        if (nextChain){
            // 最后一条链
            if(chainItem.chainIndex === this.maxChainIndex){
                const lastMatter = hourMatters[0];
                let endMinute = lastMatter.info.endTime;
                if (endMinute === -1){
                    endMinute = lastMatter.info.startTime;
                }
                const heightInfo = this.minuteToHeight(lastMatter.info.startTime, endMinute);

                chainItems.push({
                    chainMatter: [{
                        startMinute: lastMatter.info.startTime,
                        endMinute: endMinute,
                        startHeight: heightInfo.startHeight,
                        endHeight: heightInfo.endHeight,
                        topHeight: heightInfo.startHeight,
                        text: "+" + hourMatters.length.toString(),
                        color: "#F6F7F8",
                        state: 0,
                        freeWidth: 1,
                        dayIndex: 0
                    }],
                    chainIndex: 8,
                })
                return
            }
            return this.getChainItem(chainItems, hourMatters);
        }
    },
    /**
     * 按打卡时间依次取出00:00 至 23:59 的事项插入链表
     */
    getNextMatter: function(chainItem, hourMatters){
        // 第一个
        let currentMatter;
        if(hourMatters.length === 0){
            // 没了
            return false
        }else if(chainItem.chainMatter.length === 0){
            currentMatter = hourMatters.splice(0, 1)[0];
            this.insertMatter(chainItem, currentMatter, -1);
            return this.getNextMatter(chainItem, hourMatters);
        }else{
            currentMatter = chainItem.chainMatter[chainItem.chainMatter.length - 1]

        }

        let targetMatter, targetIndex = -1;

        for (let i=0, l=hourMatters.length; i<l; i++){
            const matter = hourMatters[i];
            const nextStartHeight = matter.info.startTime * 2.583;

            if(nextStartHeight >= currentMatter.endHeight){
                targetMatter = matter;
                targetIndex = i;
                break
            }
        }
        if(targetIndex >= 0){
            targetMatter = hourMatters.splice(targetIndex, 1)[0];
            this.insertMatter(chainItem, targetMatter, currentMatter.endHeight);
            return this.getNextMatter(chainItem, hourMatters)
        }else{
            // 满了
            return true
        }
    },
    insertMatter: function(chainItem, matterItem, topHeight){

        let startMinute, endMinute;
        startMinute = matterItem.info.startTime;
        endMinute = matterItem.info.endTime;
        if(startMinute === -1){
            // 数据错误
            return
        }
        if (endMinute === -1){
            // 时间点
            endMinute = startMinute;
        }

        const heightInfo = this.minuteToHeight(startMinute, endMinute);
        // 距上 距离
        if(topHeight === -1){
            topHeight = heightInfo.startHeight
        }else{
            topHeight = heightInfo.startHeight - topHeight
        }

        chainItem.chainMatter.push({
            startMinute: startMinute,
            endMinute: endMinute,
            startHeight: heightInfo.startHeight,
            endHeight: heightInfo.endHeight,
            topHeight: topHeight,
            text: matterItem.info.title,
            color: matterItem.info.color,
            state: matterItem.timeInfo.state,
            matterItem: matterItem,
            freeWidth: 1,
            dayIndex: 0,
        })
    },
    timeToMinutes: function(time){
        const pattern = /(\d{2}):(\d{2}):(\d{2})/;
        const match = time.match(pattern);
        if (match) {
            const hours = parseInt(match[1]);
            const minutes = parseInt(match[2]);
            return hours * 60 + minutes;
        } else {
            return -1; // 返回负数表示时间格式不正确
        }
    },
    /**
     * 分钟转高度
     * @param startMinute
     * @param endMinute
     * @returns {{startHeight: number, endHeight: number}}
     */
    minuteToHeight: function(startMinute, endMinute){
        // 总高度 3720 px
        // 每分钟等于2.583 px
        // 最小高度 26 px

        let startHeight = startMinute * 2.583;
        let endHeight = endMinute * 2.583;
        // 最小高度
        if (startHeight > endHeight - 26){
            endHeight = startHeight + 26
        }
        // 最大高度
        if(startHeight > 3694){
            startHeight = 3694
            endHeight = 3720
        }
        return {startHeight:startHeight, endHeight:endHeight}
    },
    /**
     * 扩展宽度
     */
    setFreeWidth: function(chainItems, dayIndex, upFoldIndex){
        chainItems.forEach((chainItem, chainIndex)=>{
            chainItem.chainMatter.forEach((matterItem,matterIndex)=>{
                // 扩展宽度
                matterItem.freeWidth = this.getFreeWidth(chainItems, chainIndex, matterItem);
                matterItem.startDayIndex = dayIndex;
                // 缩减高度
                if(upFoldIndex === -1){
                    return
                }
                const foldHeight = (upFoldIndex + 1) * 155;
                if(matterIndex === 0){
                    matterItem.topHeight = matterItem.topHeight - foldHeight;
                }
                matterItem.startHeight = matterItem.startHeight - foldHeight;
                matterItem.endHeight = matterItem.endHeight - foldHeight;
            })
        })
    },
    /**
     * 获取空余宽度
     * @param chainItems
     * @param startIndex
     * @param matterItem
     */
    getFreeWidth: function(chainItems, startIndex, matterItem){

        let freeWidth = 1;
        for (let i=0, l=chainItems.length; i<l; i ++){
            if (i <= startIndex){
                continue
            }
            const chainItem = chainItems[i]
            // 交叉事件

            const items = chainItem.chainMatter.filter((item)=>{
                return (matterItem["startHeight"] >= item["startHeight"] && matterItem["startHeight"] < item["endHeight"]) ||
                    (matterItem["startHeight"] <= item["startHeight"] && matterItem["endHeight"] > item["startHeight"])
            })


            if (items.length > 0){
                // 交叉事件
                break
            }else{
                // 宽度 + 1
                freeWidth ++
            }
        }
        return freeWidth
    }

}